import '../../assets/css/common/table.css';
import '../../assets/css/common/common.css';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { formatHtRequesterName } from '../../utils/helpers/table';

const SurveyTable = (props) => {
    const { heads, body, onClickModal, onClickRequestApplyCompetitorStore } = props;

    const getStoreRank = (storeRank) => {
        const STORE_RANK = { 0: '週2回〜', 1: '週1回', 2: '隔週', 3: '月1回' };
        return STORE_RANK[storeRank];
    };

    return (
        <table className="okc-table__main w-100" id="survey-history-table">
            <thead>
                <tr>
                    {heads &&
                        heads.map((itemHeader, index) => (
                            <th key={index} className={itemHeader.className} {...(index !== 0 && { 'data-column': 'none' })}>
                                {itemHeader.name}
                            </th>
                        ))}
                </tr>
            </thead>
            {body &&
                body.map((itemRow, index) => (
                    <tbody key={index}>
                        <tr className="no-result">
                            <th rowSpan="2">
                                <div className="d-flex">
                                    <Link to={`/price-search?competitorStoreCode=${itemRow?.competitorStoreCode}`}>
                                        {itemRow.competitorName}
                                    </Link>
                                </div>
                            </th>
                            <td
                                className={`modal-link frequency ${itemRow.highlight ? 'highlight' : ''}`}
                                rowSpan="2"
                                data-toggle="modal"
                                data-column="none"
                                onClick={() =>
                                    onClickModal(
                                        itemRow?.competitorStoreMasterId,
                                        itemRow?.competitorName,
                                        itemRow?.systemRank,
                                        itemRow?.surveyFrequencyUnitWeek,
                                    )
                                }
                            >
                                {getStoreRank(itemRow.surveyFrequencyUnitWeek)}
                            </td>
                            <td className={`${itemRow.highlight ? 'highlight' : ''}`} rowSpan="2" data-column="none">
                                {itemRow?.uninvestigatedDays}
                            </td>
                            {itemRow?.surveyList.map((item, index) => {
                                if (item.requesterDate != null) {
                                    return (
                                        <td key={index} className={`${itemRow.highlight ? 'highlight' : ''}`} data-column="none">
                                            {item.requesterDate}
                                        </td>
                                    );
                                } else {
                                    return (
                                        <td className="empty" rowSpan="2" key={index} data-column="none">
                                            -
                                        </td>
                                    );
                                }
                            })}
                            <td className="freeze-column freeze-right-0 request-apply-competitor-store" rowSpan="2" data-column="none">
                                <Button className="btn btn--icon btn--primary" onClick={() => onClickRequestApplyCompetitorStore(itemRow)}>
                                    <i className="icon-edit" />
                                </Button>
                            </td>
                        </tr>
                        <tr>
                            {itemRow?.surveyList.map((item, index) => {
                                if (item.requesterName != null) {
                                    return (
                                        <td key={index} className={`${itemRow.highlight ? 'highlight' : ''}`} data-column="none">
                                            {formatHtRequesterName(item.requesterName)}
                                        </td>
                                    );
                                }
                            })}
                        </tr>
                    </tbody>
                ))}
        </table>
    );
};

export default SurveyTable;
